import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@shared/guards/auth.service';
import { ActiveCaseComponent } from './active-case/active-case.component';
import { CaseHistoryComponent } from './casehistory/casehistory.component';
import { MyCasesComponent } from './my-cases/my-cases.component';
import { SettingsComponent } from './settings/settings.component';

const caseDashboardRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/signin' },

  { path: 'activecase', component: ActiveCaseComponent, canActivate: [AuthGuard] },

  { path: 'casehistory', component: CaseHistoryComponent, canActivate: [AuthGuard] },

  { path: 'mycases', component: MyCasesComponent, canActivate: [AuthGuard] },
  
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(caseDashboardRoutes)],
  exports: [RouterModule],
})
export class CaseDashboardRoutingModule {}
